import { Injectable, signal } from '@angular/core';
import { colorType, labelType } from '@core/types/types';

export interface toastConfig {
  ref: string;
  message: labelType;
  color: colorType;
  delay?: number;
  icon?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts = signal<toastConfig[]>([]);

  show(toast: toastConfig) {
    this.toasts.update((ts) => [...ts, toast]);
  }

  remove(ref: string) {
    this.toasts.set(this.toasts().filter((t) => t.ref !== ref));    
  }
}
